import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import AxisSpinner from "./AxisSpinner";

const DropDownCostcentreSelection = ({
  defaultValue,
  onSelected,
  trust,
  facility,
  ward,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [costCentres, setCostcentres] = useState([]);
  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    getCostcentres();
  }, [searchTerm, trust, facility, ward]);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;

    setSelected(defaultValue);
  }, [defaultValue]);

  const getCostcentres = async () => {
    try {
      setLoading(true);

      var params = {};
      if (trust !== null && trust !== undefined) {
        params["trust_id"] = trust?.id;
      }
      if (facility !== null && facility !== undefined) {
        params["facility_id"] = facility?.id;
      }
      if (ward !== null && ward !== undefined) {
        params["ward_id"] = ward?.id;
      }
      if (searchTerm !== null && searchTerm !== "") {
        params["search"] = searchTerm;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/cost_centre/all",
        null,
        config,
      );
      setCostcentres(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const selectCostcentre = (costCentre) => {
    setSelected(costCentre);
    onSelected(costCentre);
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;
    return (
      <Fragment>
        {costCentres?.map((costCentre) => (
          <Dropdown.Item
            key={costCentre?.id}
            onClick={() => selectCostcentre(costCentre)}
          >
            {costCentre?.identifier}
          </Dropdown.Item>
        ))}
      </Fragment>
    );
  };

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle className={"shift-table-dropdown"} id="dropdown-basic">
          {selected !== null ? selected?.identifier : "Cost Centres"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              margin: "8px 10px",
              width: "calc(100% - 20px)",
              borderRadius: "5px",
            }}
          />

          {selected !== null ? (
            <Dropdown.Item onClick={() => selectCostcentre(null)}>
              X Remove Selection
            </Dropdown.Item>
          ) : null}

          {SpinnerOrData(loading)}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default DropDownCostcentreSelection;
